var map = {
	"./assets/images/404.png": "3dfc",
	"./assets/images/activity1.png": "fab4",
	"./assets/images/activity2.png": "8053",
	"./assets/images/activity2/battery.png": "aab1",
	"./assets/images/activity2/gaoqing.png": "7162",
	"./assets/images/activity2/gexinghua.png": "1837",
	"./assets/images/activity2/kanglanguang.png": "3ddf",
	"./assets/images/activity2/mosha.png": "ca2c",
	"./assets/images/activity2/protect.png": "2a3e",
	"./assets/images/activity2/repair.png": "01dc",
	"./assets/images/activity3.png": "f1f4",
	"./assets/images/activity4.png": "7b53",
	"./assets/images/activity5.png": "70ae",
	"./assets/images/activity6.png": "d219",
	"./assets/images/activity7.png": "5bc1",
	"./assets/images/activitybanner.png": "69c7",
	"./assets/images/activitybanner1.png": "7931",
	"./assets/images/activityshow.png": "197b",
	"./assets/images/arrow.png": "061e",
	"./assets/images/back.png": "ae5c",
	"./assets/images/back_camera.png": "4e9e",
	"./assets/images/banner.png": "1936",
	"./assets/images/banner1.png": "d81f",
	"./assets/images/battery.png": "5a6b",
	"./assets/images/black1.png": "13e2",
	"./assets/images/black2.jpg": "2837",
	"./assets/images/blackc.png": "bd5f",
	"./assets/images/board.png": "d24b",
	"./assets/images/camera.png": "5e4f",
	"./assets/images/carousel1.png": "c81b",
	"./assets/images/carousel2.jpg": "562b",
	"./assets/images/carousel3.png": "f035",
	"./assets/images/carousel4.jpg": "6367",
	"./assets/images/carousel5.jpg": "a6da",
	"./assets/images/carousel6.jpg": "99ed",
	"./assets/images/carousel7.jpg": "9d04",
	"./assets/images/code.png": "50dc",
	"./assets/images/fa-phone.svg": "0b8a",
	"./assets/images/fa-phone1.svg": "1fae",
	"./assets/images/green1.png": "e6f6",
	"./assets/images/greenc.png": "e6a7",
	"./assets/images/headerphone.png": "b23b",
	"./assets/images/index1.png": "0c79",
	"./assets/images/index2.png": "cf94",
	"./assets/images/index3.png": "751b",
	"./assets/images/index4.png": "8502",
	"./assets/images/index5.png": "6bad",
	"./assets/images/index6.png": "3a3f",
	"./assets/images/index_phone.png": "2450",
	"./assets/images/item.png": "1594",
	"./assets/images/jdshop.png": "01fe",
	"./assets/images/location.svg": "3589",
	"./assets/images/location1.svg": "5c22",
	"./assets/images/lod.png": "9321",
	"./assets/images/logo.png": "9d64",
	"./assets/images/marker.svg": "144d",
	"./assets/images/mobilecode.png": "465f",
	"./assets/images/mobileshop.png": "3791",
	"./assets/images/new1.png": "2701",
	"./assets/images/new2.png": "3cea",
	"./assets/images/new3.png": "b8e4",
	"./assets/images/phone1.jpg": "96c7",
	"./assets/images/pink1.png": "56aa",
	"./assets/images/pinkc.png": "ea4e",
	"./assets/images/police.png": "80a3",
	"./assets/images/price1.png": "2d3e",
	"./assets/images/problems.png": "32d7",
	"./assets/images/problems1.png": "9af9",
	"./assets/images/product1.png": "6050",
	"./assets/images/product1/back.png": "a10d",
	"./assets/images/product1/black.png": "4e4b",
	"./assets/images/product1/details1.jpg": "1b04",
	"./assets/images/product1/details2.jpg": "fda9",
	"./assets/images/product1/details3.jpg": "af1a",
	"./assets/images/product1/details4.jpg": "8513",
	"./assets/images/product1/front.png": "30c5",
	"./assets/images/product1/gold.png": "a001",
	"./assets/images/product1/green.png": "fd53",
	"./assets/images/product2.png": "ec01",
	"./assets/images/product2/black.png": "20b1",
	"./assets/images/product2/black1.png": "c14c",
	"./assets/images/product2/black_front.png": "aad2",
	"./assets/images/product2/blackcircle.png": "6832",
	"./assets/images/product2/blue.png": "178f",
	"./assets/images/product2/blue1.png": "25f3",
	"./assets/images/product2/blue_front.png": "e144",
	"./assets/images/product2/bluecircle.png": "da37",
	"./assets/images/product2/front.png": "6a44",
	"./assets/images/product2/prj_01.jpeg": "3b07",
	"./assets/images/product2/prj_02.jpeg": "4ab9",
	"./assets/images/product2/prj_03.jpeg": "fb5c",
	"./assets/images/product2/prj_04.jpeg": "46a4",
	"./assets/images/product2/prj_05.jpeg": "7381",
	"./assets/images/product2/prj_06.jpeg": "c655",
	"./assets/images/product2/prj_07.jpeg": "5535",
	"./assets/images/product2/prj_08.jpeg": "8d5c",
	"./assets/images/product2/prj_09.jpeg": "8451",
	"./assets/images/product2/prj_10.jpeg": "47f3",
	"./assets/images/product2/prj_11.jpeg": "8194",
	"./assets/images/product2/prj_12.jpeg": "a75a",
	"./assets/images/product2/prj_13.jpeg": "b54b",
	"./assets/images/product2/prj_14.jpg": "80bd",
	"./assets/images/product2/purple.png": "590a",
	"./assets/images/product2/purple1.png": "8722",
	"./assets/images/product2/purple_front.png": "1e15",
	"./assets/images/product2/purplecircle.png": "fcff",
	"./assets/images/product3/banner.png": "6051",
	"./assets/images/product3/black.jpg": "c087",
	"./assets/images/product3/detail1.png": "2d84",
	"./assets/images/product3/detail2.png": "c68e",
	"./assets/images/product3/detail3.png": "fe90",
	"./assets/images/product3/detail4.png": "6037",
	"./assets/images/product3/detail5.png": "76d3",
	"./assets/images/product3/green.jpg": "ad08",
	"./assets/images/product3/product.png": "7b22",
	"./assets/images/product3/silver.jpg": "6364",
	"./assets/images/product4/black.png": "7133",
	"./assets/images/product4/blue.png": "20a0",
	"./assets/images/product4/detail1.png": "622c",
	"./assets/images/product4/detail2.png": "5a49",
	"./assets/images/product4/detail3.jpg": "3b76",
	"./assets/images/product4/detail4.png": "a2fd",
	"./assets/images/product4/green.png": "3839",
	"./assets/images/product4/instruct.png": "d8fe",
	"./assets/images/product4/instruct1.png": "421e",
	"./assets/images/product4/white.png": "b497",
	"./assets/images/repair.png": "a670",
	"./assets/images/repair1.png": "6763",
	"./assets/images/screen.png": "4a8c",
	"./assets/images/service.png": "c046",
	"./assets/images/service1.png": "3414",
	"./assets/images/shop.png": "58f6",
	"./assets/images/sim1.png": "5147",
	"./assets/images/sim2.png": "4436",
	"./assets/images/size.png": "e8ff",
	"./assets/images/tianmaoshop.png": "6fee",
	"./assets/images/time.svg": "56de",
	"./assets/images/time1.svg": "954c",
	"./assets/images/type.png": "8856",
	"./assets/images/video.png": "c59e",
	"./assets/images/wechat.png": "37c4",
	"./assets/images/weibo.png": "2d18",
	"./assets/instruction.mp4": "756d",
	"./assets/logo.png": "cf05"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "53a4";